module.exports = __webpack_public_path__ + "img/Zn(OH)2.37c12336.png";